export type Exercise = {
  id: string
  title: string
  language: 'javascript' | 'python' | 'typescript'
  difficulty: 'Easy' | 'Medium' | 'Hard'
  descriptionHtml: string
  starterCode: string
  tests: Array<{ name: string; run: (exports: any, deepEqual?: (a: any, b: any) => boolean) => { pass: boolean; message?: string } }>
}

export const EXERCISES: Exercise[] = [
  {
    id: 'sum-two-numbers',
    title: 'Sum Two Numbers',
    language: 'typescript',
    difficulty: 'Easy',
    descriptionHtml:
      '<p>Write a function <code>sum(a: number, b: number): number</code> that returns the sum of two numbers.</p>' +
      '<ul><li>Use TypeScript types.</li><li>Export your function using <code>export function sum(a: number, b: number): number { ... }</code>.</li></ul>',
    starterCode: `export function sum(a: number, b: number): number {
  // your code here
}
`,
    tests: [
      { name: 'sum(1, 2) === 3', run: ({ sum }) => ({ pass: sum && sum(1, 2) === 3, message: 'Expected 3' }) },
      { name: 'sum(0, 0) === 0', run: ({ sum }) => ({ pass: sum && sum(0, 0) === 0, message: 'Expected 0' }) },
      { name: 'sum(-1, 1) === 0', run: ({ sum }) => ({ pass: sum && sum(-1, 1) === 0, message: 'Expected 0' }) },
    ],
  },
  {
    id: 'is-palindrome',
    title: 'Is Palindrome',
    language: 'typescript',
    difficulty: 'Medium',
    descriptionHtml:
      '<p>Implement <code>isPalindrome(str: string): boolean</code> that returns true if a string is a palindrome, ignoring case and non-alphanumeric characters.</p>' +
      '<p>Export your function using <code>export function isPalindrome(str: string): boolean { ... }</code>.</p>',
    starterCode: `export function isPalindrome(str: string): boolean {
  // your code here
}
`,
    tests: [
      { name: 'racecar', run: ({ isPalindrome }) => ({ pass: isPalindrome && isPalindrome('racecar') === true, message: 'racecar => true' }) },
      { name: 'A man, a plan, a canal: Panama', run: ({ isPalindrome }) => ({ pass: isPalindrome && isPalindrome('A man, a plan, a canal: Panama') === true, message: 'Panama sentence => true' }) },
      { name: 'hello', run: ({ isPalindrome }) => ({ pass: isPalindrome && isPalindrome('hello') === false, message: 'hello => false' }) },
    ],
  },
  {
    id: 'fizz-buzz',
    title: 'FizzBuzz',
    language: 'typescript',
    difficulty: 'Easy',
    descriptionHtml:
      '<p>Write <code>fizzBuzz(n: number)</code> that returns an array of numbers from 1..n where multiples of 3 are "Fizz", multiples of 5 are "Buzz", and multiples of both are "FizzBuzz".</p>' +
      '<p>Export your function using <code>export function fizzBuzz(n: number) { ... }</code>.</p>',
    starterCode: `export function fizzBuzz(n: number) {
  
}
`,
    tests: [
      { name: 'fizzBuzz(5)', run: ({ fizzBuzz }) => {
        const expected = [1, 2, 'Fizz', 4, 'Buzz']
        const pass = fizzBuzz && JSON.stringify(fizzBuzz(5)) === JSON.stringify(expected)
        return { pass, message: 'Expected ' + JSON.stringify(expected) }
      } },
      { name: 'fizzBuzz(15) has FizzBuzz at 15', run: ({ fizzBuzz }) => ({ pass: fizzBuzz && fizzBuzz(15)[14] === 'FizzBuzz', message: 'Index 14 should be FizzBuzz' }) },
    ],
  },
  {
    id: 'py-sum-two-numbers',
    title: 'Sum Two Numbers (Python)',
    language: 'python',
    difficulty: 'Easy',
    descriptionHtml:
      '<p>Write a function <code>sum_numbers(a, b)</code> in Python that returns the sum of two numbers. Define it at module level.</p>',
    starterCode: `def sum_numbers(a, b):
    # your code here
   
`,
    tests: [
      { name: 'sum_numbers(1, 2) == 3', run: (exports) => ({ pass: exports && exports.sum_numbers && exports.sum_numbers(1, 2) === 3, message: 'Expected 3' }) },
      { name: 'sum_numbers(0, 0) == 0', run: (exports) => ({ pass: exports && exports.sum_numbers && exports.sum_numbers(0, 0) === 0, message: 'Expected 0' }) },
      { name: 'sum_numbers(-1, 1) == 0', run: (exports) => ({ pass: exports && exports.sum_numbers && exports.sum_numbers(-1, 1) === 0, message: 'Expected 0' }) },
    ],
  },
]

;(window as any).__EXERCISES__ = EXERCISES


